import axios, {AxiosRequestConfig} from 'axios';
import toast from "react-hot-toast";
import * as Sentry from "@sentry/react";
import LogRocket from "logrocket";

export const axiosInstance = axios.create({
    baseURL: 'https://api.instinctdate.app',
});

export const request = async <T>(config: AxiosRequestConfig & { withError?: boolean }) => {
    try {
        if (config.data instanceof FormData) {
            config.transformRequest = [(d) => d];
            config.headers = {...(config.headers ?? {})};
            delete (config.headers as any)['Content-Type'];
        }
        const response = await axiosInstance.request<T>(config); // ← no .catch()
        return response.data;
    } catch (error: any) {
        LogRocket.error(error);
        Sentry.captureException(error);
        const urlParts = config.url?.split('?');
        const urlString = urlParts?.length ? `${urlParts[0]}\n` : `${config.url}\n`;
        toast.error(`${urlString}${error?.response?.data?.errorMessage ?? error.message ?? 'Ошибка в запросе'}`);
        if (config.withError) {
            throw error;
        }
    }
};
